'use strict';
const RestUtils = require('utils/RestUtils'),
    apiAppUrl = process.env.URL_API,
    Security = require('./Security').auth,
    SessionStore = require('stores/SessionStore');

const BrewhouseServiceImpl = {

    fetchTask(onSuccess, onFailure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', onFailure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(JSON.parse(this.responseText));
            }, function () {
                onFailure.bind(this)(this.responseText);
            });
        });
        ajax.open('GET', apiAppUrl + '/brewhouse/' + SessionStore.getCurrentApplicant() + '/process');
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        ajax.send();
    },

    addTask(content, onSuccess, onFailure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', onFailure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess(this);
            }, function () {
                onFailure(this);
            });
        });
        ajax.open('POST', apiAppUrl + '/brewhouse/' + SessionStore.getCurrentApplicant() + '/process', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        ajax.send(JSON.stringify(content));
    },

    changeTask(content, onSuccess, onFailure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', onFailure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess(this);
            }, function () {
                onFailure.bind(this)();
            });
        });
        ajax.open('PUT', apiAppUrl + '/brewhouse/' + SessionStore.getCurrentApplicant() + '/process', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        ajax.send(JSON.stringify(content));
    },

    deleteTask(id, onSuccess, onFailure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', onFailure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess(this);
            }, function () {
                onFailure.bind(this)();
            });
        });
        ajax.open('DELETE', apiAppUrl + '/brewhouse/' + SessionStore.getCurrentApplicant() + '/process/' + id, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        ajax.send();
    }

};

module.exports = BrewhouseServiceImpl;



/** WEBPACK FOOTER **
 ** ./src/services/BrewhouseServiceImpl.js
 **/